/**
 * Catálogo de WhatsApp Flows soportados por el chatbot (chatbot_v1/core/FlowRouter.js).
 * Mantener sincronizado con FLOW_HANDLERS en ese archivo: cualquier token nuevo
 * agregado allá debe reflejarse aquí para poder asignarlo a un Step desde el CMS.
 */
export interface WhatsappFlowOption {
  token: string;
  label: string;
}

export const WHATSAPP_FLOW_OPTIONS: WhatsappFlowOption[] = [
  { token: 'STRIVE_CO_TOKEN', label: 'Strive Colombia' },
  { token: 'PRICE_CO_TOKEN', label: 'Simulador de precio' },
  { token: 'FLYERS_TOKEN', label: 'Flyers' },
  { token: 'INVOICE_TOKEN', label: 'Factura (Invoice)' },
  { token: 'CIMA_TOKEN', label: 'Cima' },
  { token: 'LOGO_TOKEN', label: 'Generación de logos' },
  { token: 'CATALOG_TOKEN', label: 'Catálogos' },
];

export const WHATSAPP_FLOW_LANGUAGES: string[] = ['es_MX', 'es_CO', 'es', 'en_US', 'pt_BR'];
